/**
 * Report-Definition für den Projekt-Überblick (DashboardTab).
 *
 * Kompakte Zusammenfassung der im Dashboard angezeigten Kennzahlen:
 * Ø Reifegrad, aktive Risiken / offene Punkte, jüngster Wochenfortschritt
 * und der geführte nächste Schritt. Bewusst knapp gehalten.
 */
import {
  buildDocument,
  buildSection,
  keyValuesBlock,
  kv,
  textBlock,
  type ReportDocument,
} from '../../../lib/pdf/reportModel';

export interface DashboardReportWeek {
  kw: number | null;
  jahr: number | null;
  erledigt: number;
  offen: number;
}

export interface DashboardReportNextStep {
  number: number;
  label: string;
}

export interface DashboardReportInput {
  /** Ø Reifegrad über alle Schritte (0–5), null wenn nichts erfasst. */
  reifegradAvg: number | null;
  /** Aktive Risiken (KPI rActive). */
  risksActive: number;
  /** Offene Punkte (KPI opOpen). */
  offenePunkteOpen: number;
  /** Jüngste Wochenmeldung; null wenn keine vorhanden. */
  latestWeek: DashboardReportWeek | null;
  /** Geführter nächster Schritt; null wenn keiner offen ist. */
  nextStep: DashboardReportNextStep | null;
}

export function buildDashboardReport(input: DashboardReportInput): ReportDocument {
  const wochenfortschritt = input.latestWeek
    ? `${input.latestWeek.erledigt} erledigt · ${input.latestWeek.offen} offen` +
      (input.latestWeek.kw != null ? ` (KW ${input.latestWeek.kw}/${input.latestWeek.jahr ?? ''})` : '')
    : '';

  const naechsterSchritt = input.nextStep
    ? `Schritt ${input.nextStep.number}: ${input.nextStep.label}`
    : '';

  return buildDocument([
    buildSection('Projekt-Überblick', [
      keyValuesBlock([
        kv('Ø Reifegrad (0–5)', input.reifegradAvg != null ? `${input.reifegradAvg.toFixed(1)} / 5` : '—'),
        kv('Risiken aktiv', String(input.risksActive)),
        kv('Offene Punkte', String(input.offenePunkteOpen)),
        kv('Wochenfortschritt', wochenfortschritt),
      ]),
    ]),
    buildSection('Geführter nächster Schritt', [
      textBlock('Nächster Schritt', naechsterSchritt),
    ]),
  ]);
}
